import React, { useState, useEffect, useMemo } from 'react';
import { Container, Row, Col, Image, Tabs, Tab } from 'react-bootstrap';
import { useUserContext } from '../UserContext';
import { useEntidadeContext } from '../EntidadeContext';
import logoImage from '../img/logo.png';
import PerfisTab from '../components/perfis/PerfisTab'; // Componente que vamos criar a seguir

const PerfisPage = () => {
    // Certifique-se de obter isLoadingAccessConfig e dynamicAccessConfig do contexto
    const { currentUserRole, getPermittedInternalTabs, isLoadingAccessConfig, dynamicAccessConfig } = useUserContext();
    const { currentEntidade } = useEntidadeContext();

    // Obter abas permitidas para Perfis
    const permittedTabs = useMemo(() => {
        return getPermittedInternalTabs('perfis', currentUserRole);
      },
      [getPermittedInternalTabs, currentUserRole, isLoadingAccessConfig, dynamicAccessConfig] // Adicione isLoadingAccessConfig e dynamicAccessConfig
    );

    const [activeTabKey, setActiveTabKey] = useState(permittedTabs[0]?.key || 'gerenciarPerfis');

    useEffect(() => {
        if (permittedTabs.length > 0 && !isLoadingAccessConfig && !permittedTabs.some(tab => tab.key === activeTabKey)) {
            setActiveTabKey(permittedTabs[0].key);
        }
        // Adicione isLoadingAccessConfig para reavaliar quando o carregamento terminar
    }, [permittedTabs, activeTabKey, isLoadingAccessConfig]); // Removido currentUserRole, pois permittedTabs já depende dele

    return (
        <div style={{ border: '1px solid gray', backgroundColor: '#f5f5f5' }}>
            <div className="header" style={{ minHeight: '80px' }}>
                <Row className="p-1 align-items-center" style={{ minHeight: 'inherit' }}>
                    <Col xs={12} md={6} style={{ minHeight: '60px' }}>
                        <div className="d-flex align-items-center justify-content-start h-100">
                            <Image src={logoImage} alt="Logo Clínica" style={{ maxHeight: '60px', marginLeft: '12px' }} />
                            <h3 style={{ marginLeft: '15px', marginBottom: '0' }}>Gestão de Perfis de Acesso</h3>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="body p-3">
                <Tabs activeKey={activeTabKey} onSelect={(k) => setActiveTabKey(k)} className="mb-3">
                    {permittedTabs.map(tabInfo => (
                        <Tab key={tabInfo.key} eventKey={tabInfo.key} title={tabInfo.title}>
                            {tabInfo.key === 'gerenciarPerfis' && (
                                <PerfisTab currentEntidade={currentEntidade} />
                            )}
                            {/* Adicionar outras abas de Perfis aqui se necessário no futuro */}
                        </Tab>
                    ))}
                </Tabs>
            </div>
        </div>
    );
};

export default PerfisPage;